import Vue from 'vue'
import '@/@fake-db/db'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import { i18n } from '@/plugins/i18n'
import App from './App.vue'
import './plugins/acl'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import './mixins/icemixin'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
